import endsWith from "lodash/endsWith";
import join from "lodash/join";
import slice from "lodash/slice";
export const COMPLETED_POSTFIX = "_COMPLETED";
export const REJECTED_POSTFIX = "_REJECTED";
const namespacesMap = {};
const namespaceAndActionDelimiter = "/";
export const actionTypesMap = {};
export function createNamespace(...args) {
    const ns = join(args, namespaceAndActionDelimiter);
    if (namespacesMap[ns]) {
        throw new Error(`Namespace '${ns}' already exists`);
    }
    namespacesMap[ns] = ns;
    return namespacesMap[ns];
}
export function createActionType(...args) {
    const at = join(args, namespaceAndActionDelimiter);
    if (actionTypesMap[at]) {
        throw new Error(`Action type '${at}' already exists`);
    }
    if ((endsWith(at, COMPLETED_POSTFIX) &&
        !actionTypesMap[join(slice(at, 0, at.length - COMPLETED_POSTFIX.length), "")]) ||
        (endsWith(at, REJECTED_POSTFIX) &&
            !actionTypesMap[join(slice(at, 0, at.length - REJECTED_POSTFIX.length), "")])) {
        throw new Error(`Incorrect '${at}': there is no action type without suffix`);
    }
    actionTypesMap[at] = at;
    return actionTypesMap[at];
}
